<template>
  <ul class="menu-nav">
    <template v-for="(data, index) in MenuList">
      <!-- Submenu Parent Item -->
      <template v-if="data.child">
        <li
          aria-haspopup="true"
          :key="index"
          data-menu-toggle="hover"
          class="menu-item menu-item-submenu"
          :class="{
            'menu-item-open-active menu-item-open': isRouteActive(
              data?.menu,
              data?.submenu
            ),
          }"
          @mouseenter="onSubmenuMouseEnter($event)"
          @mouseleave="onSubmenuMouseLeave($event)"
        >
          <!-- Menu Toggle Header -->
          <a href="#" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-lg svg-custom-menu-icon mr-4">
              <inline-svg
                :src="$assetURL('media/custom-svg/' + data?.icon + '.svg')"
              />
            </span>
            <span class="menu-text">{{ data?.title }}</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="menu-submenu">
            <span class="menu-arrow"></span>
            <ul class="menu-subnav">
              <router-link
                v-for="(submenu, submenu_index) in data?.submenu"
                :key="`${index}-${submenu_index}`"
                :to="{
                  name: submenu.route?.name,
                }"
                v-slot="{ href, navigate }"
              >
                <v-tooltip
                  right
                  content-class="custom-right-tooltip menu-tooltip-hover hide-menu-tooltip-hover"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <li
                      aria-haspopup="true"
                      data-menu-toggle="hover"
                      class="menu-item"
                      v-bind="attrs"
                      v-on="on"
                      :class="{
                        'menu-item-active': isSubmenuActive(
                          submenu.name,
                          submenu.route?.name
                        ),
                      }"
                    >
                      <a :href="href" class="menu-link" v-on:click="navigate">
                        <i class="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span class="menu-text">{{ submenu.text }}</span>
                      </a>
                    </li>
                  </template>
                  <span class="menu-tooltip-hover-target">{{
                    submenu.text
                  }}</span>
                </v-tooltip>
              </router-link>
            </ul>
          </div>
        </li>
      </template>

      <!-- Single Menu Item -->
      <template v-else>
        <template v-if="checkMenuItemPermission(data?.permission)">
          <router-link
            :key="index"
            :to="{ name: data?.route?.name }"
            v-slot="{ href, navigate }"
          >
            <v-tooltip
              right
              content-class="custom-right-tooltip menu-tooltip-hover hide-menu-tooltip-hover"
            >
              <template v-slot:activator="{ on, attrs }">
                <li
                  aria-haspopup="true"
                  data-menu-toggle="hover"
                  class="menu-item"
                  v-bind="attrs"
                  v-on="on"
                  :class="{
                    'menu-item-active': isRouteActive(data?.menu),
                  }"
                >
                  <a :href="href" class="menu-link" @click="navigate">
                    <span
                      class="svg-icon svg-icon-lg svg-custom-menu-icon mr-4"
                    >
                      <inline-svg
                        :src="
                          $assetURL('media/custom-svg/' + data?.icon + '.svg')
                        "
                      />
                    </span>
                    <span class="menu-text">{{ data?.title }} </span>
                  </a>
                </li>
              </template>
              <span class="menu-tooltip-hover-target">{{ data?.title }}</span>
            </v-tooltip>
          </router-link>
        </template>
      </template>
    </template>
  </ul>
</template>

<script>
import JwtService from "@/core/services/jwt.service";
import { mapGetters } from "vuex";

export default {
  name: "KTMenu",
  data() {
    return {
      MenuList: [],
    };
  },
  methods: {
    getGroupTitle(row) {
      if (!Array.isArray(row)) return "";
      for (let i = 0; i < row.length; i++) {
        if (row[i].group) {
          return row[i].group;
        }
      }
      return "";
    },
    hasActiveChildren(match) {
      if (!match) return false;
      return this.$route["path"].indexOf(match) !== -1;
    },
    getActiveMeta() {
      const activeMeta = this.$route.meta?.menuActive;
      const routeName = this.$route.name;
      const routePath = this.$route.path || "";
      const queryType =
        this.$route.query && this.$route.query.type
          ? String(this.$route.query.type).toLowerCase()
          : null;

      if (
        (routeName === "admin.job.create" ||
          routeName === "admin.job.update" ||
          routePath.includes("job/create") ||
          routePath.includes("job/update")) &&
        queryType === "recurring"
      ) {
        return "recurring";
      }

      return activeMeta;
    },
    isRouteActive(match, children = null) {
      const activeMeta = this.getActiveMeta();
      const currentRouteName = this.$route.name;

      if (children && Array.isArray(children)) {
        let childNames = children.map((item) => item.name);
        let childRouteNames = children.map((item) => item.route?.name);
        return (
          (activeMeta &&
            (activeMeta === match || childNames.includes(activeMeta))) ||
          (currentRouteName &&
            (currentRouteName === match ||
              childRouteNames.includes(currentRouteName)))
        );
      }

      if (activeMeta) {
        return activeMeta === match;
      }
      return currentRouteName === match;
    },
    isSubmenuActive(submenuName, routeName) {
      const activeMeta = this.getActiveMeta();
      if (activeMeta) {
        // return activeMeta === submenuName;
        return (
          activeMeta === submenuName ||
          activeMeta === routeName ||
          this.$route.name === routeName
        );
      }
      return this.$route.name === routeName;
    },
    isChildActive(row) {
      if (!Array.isArray(row)) return false;
      let isActive = false;
      for (let i = 0; i < row.length; i++) {
        isActive = this.isRouteActive(row[i].menu);
        if (isActive) {
          return isActive;
        }
      }
      return isActive;
    },
    checkMenuItemPermission(permission) {
      if (!permission) return true;
      if (typeof this.getPermission === "function") {
        return (
          this.getPermission(permission) ||
          this.getPermission(permission + ":view")
        );
      }
      return true;
    },

    getMenuList() {
      const _this = this;
      try {
        const result = JwtService.menuList();
        const arrays = [];
        const objects = [];
        const topTwo = [];
        const lastOne = [];
        for (const menu in result) {
          if (_this.lodash.isArray(result[menu])) {
            arrays.push(result[menu]);
          } else if (
            _this.lodash.isObject(result[menu]) &&
            result[menu].order <= 1
          ) {
            topTwo.push(result[menu]);
          } else if (
            _this.lodash.isObject(result[menu]) &&
            result[menu].order >= 21
          ) {
            lastOne.push(result[menu]);
          } else if (_this.lodash.isObject(result[menu])) {
            objects.push(result[menu]);
          }
        }
        _this.MenuList = [...topTwo, ...arrays, ...objects, ...lastOne];

        if (_this.lodash.isEmpty(_this.MenuList)) {
          JwtService.destroyToken();
        }
      } catch (error) {
        _this.logError(error);
        JwtService.destroyToken();
      }
    },
    toRemoveSubmenu(name, toRemoveSubmenuName) {
      const _submenu = this.MenuList.find(
        (menu) => menu.name === name
      )?.submenu;
      if (!_submenu) return { submenu: [], mod_submenu: [], req_idx: -1 };
      const mod_submenu = _submenu.filter((v) => v.name != toRemoveSubmenuName);
      const req_idx = this.MenuList.findIndex((v) => v.name == name);
      return {
        submenu: _submenu,
        mod_submenu: mod_submenu,
        req_idx,
      };
    },
    onSubmenuMouseEnter(event) {
      if (
        document.body.classList.contains("aside-minimize") &&
        !document.body.classList.contains("aside-minimize-hover")
      ) {
        const itemEl = event.currentTarget;
        const submenuEl = itemEl.querySelector(".menu-submenu");
        if (submenuEl && itemEl) {
          const rect = itemEl.getBoundingClientRect();
          submenuEl.style.top = `${rect.top}px`;
        }
      }
    },
    onSubmenuMouseLeave(event) {
      const itemEl = event.currentTarget;
      const submenuEl = itemEl?.querySelector(".menu-submenu");
      if (submenuEl) {
        submenuEl.style.top = "";
      }
    },
  },
  computed: {
    ...mapGetters(["localDB"]),
  },
  mounted() {
    this.getMenuList();
  },
};
</script>
